import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { RmsModule } from '@rms';
import { UtilModule } from '@utils';
import { Column, HeaderButton, ContactModel, ContactFieldKey } from '@interfaces';
import { WebService, lastValueFrom, PopupService, InventoryDataService, PromptService, EmailService, NavTabService, RmsMessageService, EmailTemplateService, PdfService } from '@services';
import { RmsFileExplorerComponent } from '../../../../custom-modules/rms-module/rms-file-explorer/rms-file-explorer.component';
export interface SupplierFromRequestModel {
  SupplierRequestID?: number | string;

  // Supplier identity
  SupplierID?: number | null;          // null = new supplier
  SupplierName?: string;

  // Basic / certifications
  SupplierContactCountry?: string;
  SupplierFDA?: string;
  SupplierFLOID?: string;
  SupplierFTUSAID?: string;
  SupplierContactSkypeHandle?: string;

  // Trader contact (stored as SupplierContact string in DB, but we edit as parts)
  TraderContactFirstName?: string;
  TraderContactLastName?: string;
  SupplierEmail?: string;
  SupplierTel?: string;
  SupplierStreet?: string;
  SupplierCity?: string;
  SupplierState?: string;
  SupplierZip?: string;

  // Approval / rejection emails
  AppRejEmailNo1?: string;
  AppRejEmailNo2?: string;
  AppRejEmailNo3?: string;

  // Trader secondary emails
  TraderSecondaryEmail1?: string;
  TraderSecondaryEmail2?: string;
  TraderSecondaryEmail3?: string;

  // Traffic contact
  TrafficContactFirstName?: string;
  TrafficContactLastName?: string;
  SupplierTrafficEmail?: string;
  TrafficNo?: string;

  // Traffic secondary emails
  TrafficSecondaryEmail1?: string;
  TrafficSecondaryEmail2?: string;
  TrafficSecondaryEmail3?: string;

  // Price Fix contact
  PriceFixFirstName?: string;
  PriceFixLastName?: string;
  PriceFixEmail?: string;
  PriceFixPhone?: string;

  // Price Fix secondary emails
  PriceFixSecondaryEmail1?: string;
  PriceFixSecondaryEmail2?: string;
  PriceFixSecondaryEmail3?: string;

  // Helpful meta
  responder?: string;
}

export interface RequestFileItem {
  file?: string;     // display name (ex: OrganicCert.pdf)
  id?: string;
  size?: number;
  uid?: string;
  url?: string;      // plumsail/azure blob url
}

function getExtWithDot(name: string): string {
  const i = name.lastIndexOf('.');
  return i >= 0 ? name.slice(i).toLowerCase() : '';
}
function sanitizeFilename(name: string): string {
  return name
    .replace(/[\\\/:\*\?"<>\|]+/g, ' - ')
    .replace(/\s{2,}/g, ' ')
    .trim();
}

@Component({
  selector: 'app-suppliers',
  imports: [RmsModule, UtilModule],
  templateUrl: './suppliers.component.html',
  styleUrl: './suppliers.component.scss'
})
export class SuppliersComponent implements OnInit {
  @ViewChild(RmsFileExplorerComponent) fileExplorer?: RmsFileExplorerComponent;
  constructor(private web: WebService,
    private inventorydata: InventoryDataService,
    private prompt: PromptService,
    private email: EmailService,
    private message: RmsMessageService,
    private nav: NavTabService,
    private tempalte: EmailTemplateService,
    private pdf: PdfService,
    private popup: PopupService,
    private sanitizer: DomSanitizer
) { }
  radioOptions: any[] = [{ value: 1, label: "Suppliers" }, { value: 2, label: "Truckers" }, { value: 3, label: "Warehouse" }, { value: 4, label: "Supplier Requests" }]
  selectedView: { value: number; label: string } | any = this.radioOptions[0];
  SupplierUpdated: boolean = false;
  RequestFiles: RequestFileItem[] = [];
  RequestFilesDestFolder: string = '';
  HeaderButtons: HeaderButton[] = [
    { label: 'Create New', icon: 'add', onAction: () => this.NewVenderWindow() },
    {
      label: 'Change Table (Viewing: ' + this.selectedView.label + ')', menu:
        [
          { onAction: () => { this.selectedView = { value: 1, label: "Suppliers" }; this.SelectedVender = null }, label: "Suppliers" },
          { onAction: () => { this.selectedView = { value: 2, label: "Truckers" }; this.SelectedVender = null }, label: "Truckers" },
          { onAction: () => { this.selectedView = { value: 3, label: "Warehouses" }; this.SelectedVender = null }, label: "Warehouse" },
          { onAction: () => { this.selectedView = { value: 4, label: "Supplier Requests" }; this.SelectedVender = null }, label: "Supplier Requests" }
        ]
    }
  ]
  SupplierHeaderButtons: HeaderButton[] = [{
    label: 'Add New',
    onAction: () => this.AddSuplierAppRejectEmail('appRej'),
    class: 'btn-bg-green'
  }]
  SupplierTraderHeaderButtons: HeaderButton[] = [{
    label: 'Add New',
    onAction: () => this.AddSuplierAppRejectEmail('trader'),
    class: 'btn-bg-green'
  }]
  SupplierTrafficHeaderButtons: HeaderButton[] = [{
    label: 'Add New',
    onAction: () => this.AddSuplierAppRejectEmail('traffic'),
    class: 'btn-bg-green'
  }]
  SupplierPriceFixHeaderButtons: HeaderButton[] = [{
    label: 'Add New',
    onAction: () => this.AddSuplierAppRejectEmail('pricefix'),
    class: 'btn-bg-green'
  }]
  private supplierFieldMap = [
    // --- Basic Info ---
    { req: 'CompanyName', db: 'SupplierName' },
    { req: 'Country', db: 'SupplierContactCountry' },
    { req: 'FDARegistration', db: 'SupplierFDA' },
    { req: 'FLOID', db: 'SupplierFLOID' },
    { req: 'FTUSAID', db: 'SupplierFTUSAID' },
    { req: 'TraderMessenger', db: 'SupplierContactSkypeHandle' },

    { req: 'PSS1Email', db: 'AppRejEmailNo1' },
    { req: 'PSS2Email', db: 'AppRejEmailNo2' },
    { req: 'PSS3Email', db: 'AppRejEmailNo3' },

    // --- Trader Contact ---
    { req: 'TraderContactFirstName', db: 'TraderContactFirstName' },
    { req: 'TraderContactLastName', db: 'TraderContactLastName' },
    { req: 'TraderContactEmail', db: 'SupplierEmail' },
    { req: 'TraderPhone', db: 'SupplierTel' },
    { req: 'TraderStreetAddress', db: 'SupplierStreet' },
    { req: 'TraderCity', db: 'SupplierCity' },
    { req: 'TraderState', db: 'SupplierState' },
    { req: 'TraderPostalCode', db: 'SupplierZip' },

    { req: 'TraderSecondaryEmail1', db: 'TraderSecondaryEmail1' },
    { req: 'TraderSecondaryEmail2', db: 'TraderSecondaryEmail2' },
    { req: 'TraderSecondaryEmail3', db: 'TraderSecondaryEmail3' },

    // --- Traffic ---
    { req: 'TrafficFirstName', db: 'TrafficContactFirstName' },
    { req: 'TrafficLastName', db: 'TrafficContactLastName' },
    { req: 'TrafficEmail', db: 'SupplierTrafficEmail' },
    { req: 'TrafficPhone', db: 'TrafficNo' },

    { req: 'TrafficSecondaryEmail1', db: 'TrafficSecondaryEmail1' },
    { req: 'TrafficSecondaryEmail2', db: 'TrafficSecondaryEmail2' },
    { req: 'TrafficSecondaryEmail3', db: 'TrafficSecondaryEmail3' },

    // --- Price Fix ---
    { req: 'PriceFixFirstName', db: 'PriceFixFirstName' },
    { req: 'PriceFixLastName', db: 'PriceFixLastName' },
    { req: 'PriceFixEmail', db: 'PriceFixEmail' },
    { req: 'PriceFixPhone', db: 'PriceFixPhone' },

    { req: 'PriceFixSecondaryEmail1', db: 'PriceFixSecondaryEmail1' },
    { req: 'PriceFixSecondaryEmail2', db: 'PriceFixSecondaryEmail2' },
    { req: 'PriceFixSecondaryEmail3', db: 'PriceFixSecondaryEmail3' },
  ];
  CurrentSupplierRaw: any | null = null;
  CurrentSupplierCompare: SupplierFromRequestModel | null = null;
  get HeaderButtonsBound(): HeaderButton[] {
    this.HeaderButtons[1].label = `Change Table (Viewing: ${this.selectedView.label})`;
    if (this.selectedView.value === 4) {
      return [this.HeaderButtons[1]]
    }
    return this.HeaderButtons;
  }
  SupplierRequestID: any = null;
  FormResponses = []
  Suppliers = []
  Warehouses = []
  Truckers = []
  Countries = []
  Regions = [];
  Cities = [];
  SupplierRequests: any = [];
  SupplierEmails: any = [];
  TraderEmails: any = [];
  TrafficEmails: any = [];
  PriceFixEmails: any = [];
  radiovalue: number = 1;
  SelectedVender: any = null;
  supplierFolderRootPath: string = ''
  RequestEditModel: SupplierFromRequestModel | null = null;
  RequestMode: 'new' | 'update' = 'new';
  RequestMergePreviewJson: string = '';

  TraderContactFields: ContactModel[] = [];
  TrafficContactFields: ContactModel[] = [];
  supplierEmailsColumns: Column[] = [
    {label: 'Approval Rejection Email', key: "Email"},
  ]
  supplierTraderEmailsColumns: Column[] = [
    { label: 'Trader Secondary Email', key: "Email" },
  ]
  supplierTrafficEmailsColumns: Column[] = [
    { label: 'Traffic Secondary Email', key: "Email" },
  ]
  supplierPriceFixEmailsColumns: Column[] = [
    { label: 'Price Fix Secondary Email', key: "Email" },
  ]
  WarehouseColumns: Column[] = [
    { label: "Warehouse Name", key: 'LocationName' }
  ]
  SupplierColumns: Column[] = [
    { label: "Supplier Name", key: 'SupplierName' }
  ]
  TruckerColumns: Column[] = [
    { label: "Trucker Name", key: 'TruckerName' }
  ]
  SupplierRequestColumns: Column[] = [
    { label: "Supplier Name", key: 'CompanyName' }
  ]


  async ngOnInit() {
    const data = await this.inventorydata.getData({
      keys: [
        'Regions',
        'Suppliers',
        'Truckers',
        'ArrivalPorts',
        'ArrivalTerminals',
        'DestinationPorts',
        'DestinationWarehouses',
        'OriginPorts',
        'Countries'
      ]
    });

    this.Suppliers = data['Suppliers'];
    this.Warehouses = data['DestinationWarehouses'];
    this.Truckers = data['Truckers'];
    this.Countries = data['Countries'];
    this.Regions = data['Regions'];
    this.Cities = data['DestinationPorts'];

    const Requests = await lastValueFrom(
      this.web.getWebCall('venders', 'supplier_requests')
    );

    this.SupplierRequests = Array.isArray(Requests)
      ? Requests.map(r => this.hydrateSupplierRequestListRow(r))
      : [];

    // ✅ consume tab data ONCE
    const tabData = this.nav.consumeActiveTabData<{ SupplierRequestID?: any }>();

    if (tabData?.SupplierRequestID) {
      const selectedRequest = this.SupplierRequests.find(
        (r: any) => r.SupplierRequestID == tabData.SupplierRequestID
      );

      if (selectedRequest) {
        this.selectedView = { value: 4, label: 'Supplier Requests' };
        this.SelectVender(selectedRequest);
      }
    }
  }


  dataSwitcher(): any {
    switch (this.selectedView.value) {
      case 1: return this.Suppliers;
      case 2: return this.Truckers;
      case 3: return this.Warehouses;
      case 4: return this.SupplierRequests;
      default: return this.Suppliers;
    }
  }

  columnSwitcher(): Column[] {
    switch (this.selectedView.value) {
      case 1: return this.SupplierColumns;
      case 2: return this.TruckerColumns;
      case 3: return this.WarehouseColumns;
      case 4: return this.SupplierRequestColumns;
      default: return this.SupplierColumns;
    }
  }

  getHeaderButtons(): HeaderButton[] {
    return [
      { label: 'Create New', icon: 'add', onAction: () => this.NewVenderWindow() },
      {
        label: `Change Table (Viewing: ${this.selectedView.label})`,
        menu: [
          { onAction: () => { this.selectedView = { value: 1, label: 'Suppliers' }; this.SelectedVender = null}, label: 'Suppliers' },
          { onAction: () => { this.selectedView = { value: 2, label: 'Truckers' }; this.SelectedVender = null }, label: 'Truckers' },
          { onAction: () => { this.selectedView = { value: 3, label: 'Warehouses' }; this.SelectedVender = null }, label: 'Warehouse' },
          { onAction: () => { this.selectedView = { value: 4, label: 'Supplier Requests' }; this.SelectedVender = null }, label: 'Supplier Requests' }
        ]
      }
    ];
  }
  SelectVender(vender: any) {
    this.SelectedVender = null;
    this.SelectedVender = vender;
    if (this.selectedView.value == 1) {
      this.supplierFolderRootPath = `suppliers/supplier-${vender.SupplierID}`
    }
    switch (this.selectedView.value) {
      case 1: this.SupplierSelected(vender); break;
      case 2: this.TruckerSelected(vender); break;
      case 3: this.WarehouseSelected(vender); break;
      case 4: this.SupplierRequestSelected(vender); break;
    }
  }
  SupplierSelected(vender: any) {
    const mapWithName = (obj: any, fields: string[]) =>
      fields
        .map(field => ({
          Email: (obj?.[field] ?? '').toString().trim(),
          Field: field
        }))
        .filter(x => x.Email.length > 0);

    this.SupplierEmails = mapWithName(vender, [
      'AppRejEmailNo1',
      'AppRejEmailNo2',
      'AppRejEmailNo3'
    ]);

    this.TraderEmails = mapWithName(vender, [
      'TraderSecondaryEmail1',
      'TraderSecondaryEmail2',
      'TraderSecondaryEmail3'
    ]);

    this.TrafficEmails = mapWithName(vender, [
      'TrafficSecondaryEmail1',
      'TrafficSecondaryEmail2',
      'TrafficSecondaryEmail3'
    ]);

    this.PriceFixEmails = mapWithName(vender, [
      'PriceFixSecondaryEmail1',
      'PriceFixSecondaryEmail2',
      'PriceFixSecondaryEmail3'
    ]);
  }
  TruckerSelected(vender: any) {

  }
  WarehouseSelected(vender: any) {

  }
  get TraderContactFieldsBound(): ContactModel[] {
    const v = this.SelectedVender ?? {};
    const full = (v.SupplierContact ?? '').toString().trim();
    const parts = full ? full.split(/\s+/) : [];
    const firstName = parts[0] ?? '';
    const lastName = parts.length > 1 ? parts.slice(1).join(' ') : '';

    const contactField: ContactModel[] = [{
      firstName,
      lastName,
      email: v.SupplierEmail ?? '',
      phone: v.SupplierTel ?? '',
      messenger: v.SupplierContactSkypeHandle ?? '',
      tollFree: v.SupplierTollFree ?? '',
      fax: v.SupplierFax ?? '',
      street1: v.SupplierStreet ?? '',
      state: v.SupplierState ?? '',
      city: v.SupplierCity ?? '',
      postalCode: v.SupplierZip ?? '',
      country: v.SupplierContactCountry ?? ''
    }];

    return contactField;
  }

  get TrafficContactOptionsBound(): ContactFieldKey[] {
    return ['firstName', 'lastName', 'email', 'phone', 'fax'];
  }
  get TrafficeContactFieldsBound(): ContactModel[] {
    const v = this.SelectedVender ?? {};
    const full = (v.TrafficContact ?? '').toString().trim();
    const parts = full ? full.split(/\s+/) : [];
    const firstName = parts[0] ?? '';
    const lastName = parts.length > 1 ? parts.slice(1).join(' ') : '';

    const contactField: ContactModel[] = [{
      firstName,
      lastName,
      email: v.SupplierTrafficEmail ?? '',
      phone: v.TrafficNo ?? '',
      fax: v.SupplierTrafficFax ?? ''
    }];

    return contactField;
  }
  get PriceFixContactOptionsBound(): ContactFieldKey[] {
    return ['firstName', 'lastName', 'email', 'phone', 'fax'];
  }
  get PriceFixContactFieldsBound(): ContactModel[] {
    const v = this.SelectedVender ?? {};

    const contactField: ContactModel[] = [{
      firstName: v.PriceFixFirstName,
      lastName: v.PriceFixLastName,
      email: v.PriceFixEmail ?? '',
      phone: v.PriceFixPhone ?? '',
    }];

    return contactField;
  }
  async AddSuplierAppRejectEmail(emailType: string) {
    const SupplierID = this.SelectedVender?.SupplierID;
    let prompText = '';
    switch (emailType){
      case 'appRej':
        prompText = 'Add Supplier Approval/Rejection Email'
        break;
      case 'trader':
        prompText = 'Add Supplier Trader Secondary Email';
        break;
      case 'traffic':
        prompText = 'Add Supplier Traffic Secondary Email';
        break;
      default:
        prompText = 'Add Supplier Price Fix Secondary Email'
    }
    const { closed$ } = this.prompt.open({
      promptInput: 'text',
      inputLabel: 'Email',
      buttons: [{ label: 'OK' }],
      inputRequired: true,
      promptText: prompText
    })
    closed$.subscribe(async (response: any) => {
      console.log(response.inputValue);
      if (!response.inputValue.includes("@")) {
        window.alert("Please enter a valid email address.");
        return;
      }
      const email = response.inputValue;
      const payload = [{ value: email, name: "Email" }, { value: this.SelectedVender.SupplierID, name: 'SupplierID' }, { value: emailType, name: 'EmailType'}]
      try {
        await lastValueFrom(this.web.getWebCall('venders', '/addAppRejEmail', { params: payload }));
        await this.ngOnInit();
        this.SelectVender(this.Suppliers.find((s: any) => s.SupplierID == SupplierID));
        this.message.success("Added Email.");
      }
      catch (error) {
        console.error('Error adding email:', error);
      }
    });
  }
  NewVenderWindow() {
    this.SelectedVender = {};
  }
  UpdateTraderContact(contact: ContactModel) {
    this.SelectedVender.SupplierContact = [contact.firstName, contact.lastName].filter(Boolean).join(' ');
    this.SelectedVender.SupplierEmail = contact.email;
    this.SelectedVender.SupplierTel = contact.phone;
    this.SelectedVender.SupplierContactSkypeHandle = contact.messenger;
    this.SelectedVender.SupplierTollFree = contact.tollFree;
    this.SelectedVender.SupplierFax = contact['fax'];
    this.SelectedVender.SupplierStreet = contact.street1;
    this.SelectedVender.SupplierState = contact.state;
    this.SelectedVender.SupplierCity = contact.city;
    this.SelectedVender.SupplierZip = contact.postalCode;
    this.SelectedVender.SupplierContactCountry = contact.country;

    this.UpdateSupplier();
  }
  UpdateTrafficContact(contact: ContactModel) {
    this.SelectedVender.TrafficContact = [contact.firstName, contact.lastName].filter(Boolean).join(' ');
    this.SelectedVender.SupplierTrafficEmail = contact.email;
    this.SelectedVender.TrafficNo = contact.phone;
    this.SelectedVender.SupplierTrafficFax = contact['fax'];

    this.UpdateSupplier();
  }
  UpdatePriceFixContact(contact: ContactModel) {
    this.SelectedVender.PriceFixFirstName = contact.firstName;
    this.SelectedVender.PriceFixLastName = contact.lastName;
    this.SelectedVender.PriceFixPhone = contact.phone;
    this.SelectedVender.PriceFixEmail = contact.email;

    this.UpdateSupplier();
  }
  UpdateNames() {
    // Build full names
    this.SelectedVender.SupplierContact =
      `${this.SelectedVender.TraderContactFirstName ?? ''} ${this.SelectedVender.TraderContactLastName ?? ''}`.trim();

    this.SelectedVender.TrafficContact =
      `${this.SelectedVender.TrafficContactFirstName ?? ''} ${this.SelectedVender.TrafficContactLastName ?? ''}`.trim();

    // Validate emails BEFORE updating
    if (!this.CheckEmails()) {
      return; // stops the update
    }

    this.UpdateSupplier();
  }
  private CheckEmails(): boolean {
    if (!this.SelectedVender) return false;

    // Practical email validation (not overly strict, not overly permissive)
    const emailRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

    // Map of "label to show user" -> "property name on SelectedVender"
    const emailFields: Array<{ label: string; key: any }> = [
      { label: 'Trader Contact Email', key: 'SupplierEmail' },
      { label: 'Traffic Contact Email', key: 'SupplierTrafficEmail' },
      { label: 'Price Fix Email', key: 'PriceFixEmail' },

      { label: 'Approval/Rejection Email 1', key: 'AppRejEmailNo1' },
      { label: 'Approval/Rejection Email 2', key: 'AppRejEmailNo2' },
      { label: 'Approval/Rejection Email 3', key: 'AppRejEmailNo3' },

      { label: 'Trader Secondary Email 1', key: 'TraderSecondaryEmail1' },
      { label: 'Trader Secondary Email 2', key: 'TraderSecondaryEmail2' },
      { label: 'Trader Secondary Email 3', key: 'TraderSecondaryEmail3' },

      { label: 'Traffic Secondary Email 1', key: 'TrafficSecondaryEmail1' },
      { label: 'Traffic Secondary Email 2', key: 'TrafficSecondaryEmail2' },
      { label: 'Traffic Secondary Email 3', key: 'TrafficSecondaryEmail3' },

      { label: 'Price Fix Secondary Email 1', key: 'PriceFixSecondaryEmail1' },
      { label: 'Price Fix Secondary Email 2', key: 'PriceFixSecondaryEmail2' },
      { label: 'Price Fix Secondary Email 3', key: 'PriceFixSecondaryEmail3' },
    ];

    const invalid: Array<{ label: string; value: string }> = [];

    for (const f of emailFields) {
      const raw = this.SelectedVender[f.key] as unknown as string | null | undefined;
      if (raw == null) continue;

      const value = raw.trim();

      // If empty, ignore (only validate filled-in fields)
      if (!value) {
        // optional: normalize blanks back into the model
        if (raw !== value) (this.SelectedVender[f.key] as any) = value;
        continue;
      }

      // Optional: write back trimmed version to keep data clean
      if (raw !== value) (this.SelectedVender[f.key] as any) = value;

      if (!emailRegex.test(value)) {
        invalid.push({ label: f.label, value });
      }
    }

    if (invalid.length) {
      const msg =
        `Please correct the following invalid email address${invalid.length > 1 ? 'es' : ''} before saving:\n` +
        invalid.map(x => `• ${x.label}: "${x.value}"`).join('\n');

      // Use whatever your app uses for messaging:
      // this.snackBar.open(msg, 'OK', { duration: 8000 });
      // this.messageService.error(msg);
      // this.dialogService.alert(msg);

      alert(msg); // <-- replace with your UI message system
      return false;
    }

    return true;
  }
  async UpdateSupplier() {
    const res = await lastValueFrom(this.web.getWebCall('venders', '/merge_supplier', { body: { supplierJson: JSON.stringify(this.SelectedVender) } }))
    await this.ngOnInit();
    this.SelectVender(this.Suppliers.find((s: any) => s.SupplierID == res[0]['SupplierID']));
  }
  get TruckerDispatchContactOptionsBound(): ContactFieldKey[] {
    return ['ContactName', 'Telephone', 'RatesTelephone', 'TrackingTelephone']
  }
  get TruckerDispatchContactFieldsBound(): ContactModel[] {
    const v = this.SelectedVender ?? {};

    const contactField: ContactModel[] = [{
      ContactName: v.DispatchContact,
      Telephone: v.PhoneNumber,
      RatesTelephone: v.RateContactNumber ?? '',
      TrackingTelephone: v.TrackingContactNumber ?? '',
    }];
    return contactField;
  }
  get TruckerAccountContactOptionsBound(): ContactFieldKey[] {
    return ['contact', 'phoneNumber', 'ext', 'cellPhone', 'emailAddress', 'street', 'city', 'state', 'postalCode']
  }
  get TruckersAccountContactFieldsBound(): ContactModel[] {
    const v = this.SelectedVender ?? {};

    const contactField: ContactModel[] = [{
      contact: v.SalesRep,
      phoneNumber: v.SalesRepPhone,
      ext: v.SalesRepExtension,
      cellPhone: v.SalesRepCell,
      emailAddress: v.SalesRepEmail,
      street: v.StreetAddress,
      city: v.City,
      state: v.State,
      postalCode: v.ZipCode
    }]

    return contactField;
  }
  UpdateTruckerDispatchContact(contact: ContactModel) {
    this.SelectedVender.DispatchContact = contact['ContactName'];
    this.SelectedVender.PhoneNumber = contact['Telephone'];
    this.SelectedVender.RateContactNumber = contact['RatesTelephone'];
    this.SelectedVender.TrackingContactNumber = contact['TrackingTelephone'];

    this.UpdateTrucker();
  }
  UpdateTruckerAccountContact(contact: ContactModel) {
    this.SelectedVender.SalesRep = contact['contact'];
    this.SelectedVender.SalesRepPhone = contact['phoneNumber'];
    this.SelectedVender.SalesRepExtension = contact['ext'];
    this.SelectedVender.SalesRepCell = contact['cellPhone'];
    this.SelectedVender.SalesRepEmail = contact['emailAddress'];
    this.SelectedVender.StreetAddress = contact['street'];
    this.SelectedVender.City = contact['city'];
    this.SelectedVender.State = contact['state'];
    this.SelectedVender.ZipCode = contact['postalCode'];

    this.UpdateTrucker();
  }
  async UpdateTrucker() {
    const res = await lastValueFrom(this.web.getWebCall('venders', '/merge_trucker', { body: { truckerJson: JSON.stringify(this.SelectedVender) } }))
    await this.ngOnInit();
    this.SelectedVender = this.Truckers.find((s: any) => s.TruckerID == res[0]['TruckerID']);
  }
  get WarehouseContactOptionsBound(): ContactFieldKey[] {
    return ['firstName', 'lastName', 'phone', 'fax', 'street1', 'city', 'state', 'postalCode']
  }
  get WarehouseContactFieldsBound(): ContactModel[] {
    const v = this.SelectedVender ?? {};

    const full = (v.LocationContact ?? '').toString().trim();
    const parts = full ? full.split(/\s+/) : [];
    const firstName = parts[0] ?? '';
    const lastName = parts.length > 1 ? parts.slice(1).join(' ') : '';
    const contactField: ContactModel[] = [{
      firstName,
      lastName,
      phone: v.LocationPhone ?? '',
      fax: v.LocationFax ?? '',
      street1: v.LocationStreet ?? '',
      city: v.LocationCity ?? '',
      state: v.LocationState ?? '',
      postalCode: v.LocationZipCode ?? ''
    }]

    return contactField;
  }

  UpdateWarehouseContact(contact: ContactModel) {
    this.SelectedVender.LocationContact = [contact.firstName, contact.lastName].filter(Boolean).join(' ');
    this.SelectedVender.LocationPhone = contact.phone;
    this.SelectedVender.LocationFax = contact['fax'];
    this.SelectedVender.LocationStreet = contact.street1;
    this.SelectedVender.LocationCity = contact.city;
    this.SelectedVender.LocationState = contact.state;
    this.SelectedVender.LocationZipCode = contact.postalCode;

    this.UpdateWarehouse();
  }
  async UpdateWarehouse() {
    const res = await lastValueFrom(this.web.getWebCall('venders', '/merge_location', { body: { locationJson: JSON.stringify(this.SelectedVender) } }))
    await this.ngOnInit();
    this.SelectedVender = this.Warehouses.find((s: any) => s.LocationID == res[0]['LocationID']);
  }
  UpdateStorageRate(rate: any) {
    this.SelectedVender.LocationMonthlyStorageRate = (rate / 100)
    this.SelectedVender.VenderUpdated = true;
  }
  convertToPercent(num: number) {
    return (num * 100).toFixed(2);
  }
  async sendSupplierFormEmail() {
    let attachments: any = [];
    if (this.SelectedVender.SupplierID) {
      const pdf = await this.pdf.GeneratePDF('/assets/pdf-templates/supplier-info.template.html', `${this.SelectedVender.SupplierName} - Current Data`, this.buildSupplierPdfReplacements(this.SelectedVender))
      attachments = [{
        fileName: pdf.fileName,
        contentBase64: pdf.base64,
        contentType: 'application/pdf'
      }]
    }
    let path = '/assets/email-templates/supplier-form.html';
    if (this.SelectedVender.SupplierID) {
      path = '/assets/email-templates/update-supplier-form.html'
    }
    this.email.open({
      title: 'Send Supplier Form',
      defaultFrom: localStorage['email'],
      to: this.SelectedVender.SupplierEmail ? [this.SelectedVender.SupplierEmail] : [],
      cc: [],
      subject: 'Supplier Information Form',
      templatePath: path,
      templateReplacements: {
        '@@Supplier@@': this.SelectedVender.SupplierName,
        '@@SupplierFormLink@@': `https://royalny.us.plumsail.io/64584c11-acd5-4ca4-ac6a-2ce45fe0e846${this.SelectedVender.SupplierID ? `?SupplierID=${this.SelectedVender.SupplierID}` : ''}`
      },
      attachments: attachments,
      requireTo: true,
      requireSubject: true,
      dearName: this.SelectedVender.SupplierName
    }).subscribe(async result => {
      if (result.cancelled) return;
      try {
        await lastValueFrom(this.web.getWebCall('email', 'email/send', { body: result.payload }))
        this.message.success('Email Sent to Supplier')
      }
      catch (err) {
        console.log(err);
        this.message.error('Email Failed To Send.');
      }
    });

  }
  private hydrateSupplierRequestListRow(row: any): any {
    // Parse SupplierRequestJSON into top-level props so rms-table can read CompanyName
    let parsed: any = null;
    const raw = row?.SupplierRequestJSON;

    try {
      if (raw && typeof raw === 'string') parsed = JSON.parse(raw);
      else if (raw && typeof raw === 'object') parsed = raw;
    } catch {
      parsed = null;
    }

    const result = { ...row, ...(parsed ?? {}) };

    // Normalize the table fields you display
    result.CompanyName = (result.CompanyName ?? '').toString();
    result.SupplierID = (result.SupplierID ?? '').toString();

    return result;
  }
  private parseSupplierRequestJSON(value: any): Record<string, any> | null {
    if (!value) return null;

    // If backend already returns an object, accept it
    if (typeof value === 'object') return value as Record<string, any>;

    if (typeof value !== 'string') return null;

    const trimmed = value.trim();
    if (!trimmed) return null;

    try {
      return JSON.parse(trimmed);
    } catch {
      // Sometimes JSON is double-encoded or has leading/trailing junk
      // Try a basic cleanup pass (optional but helpful)
      try {
        const cleaned = trimmed
          .replace(/^\uFEFF/, '')              // remove BOM
          .replace(/^[^\[{]*?(\{)/, '$1')      // keep from first {
          .replace(/(\})[^\}]*$/, '$1');       // keep to last }
        return JSON.parse(cleaned);
      } catch {
        return null;
      }
    }
  }

  scrollToSection(id: string) {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }
  UpdateSupplierEmail(row: any) {
    const { closed$ } = this.prompt.open({
      promptText: `Update Email ${row.Email}`,
      promptInput: 'text',
      buttons: [{ value: 1, label: 'Save', buttonClass: 'btn-bg-green' }]
    });
    closed$.subscribe(async (response: any) => {
      console.log(response.inputValue);
      if (!response.inputValue.includes("@")) {
        window.alert("Please enter a valid email address.");
        return;
      }
      const email = response.inputValue;
      this.SelectedVender[row.Field] = email;

      this.UpdateSupplier();
    });
  }
  private buildSupplierModelFromRequest(reqRow: any): SupplierFromRequestModel {
    // 1) Parse SupplierRequestJSON (or accept object)
    let reqPayload: any = reqRow;
    const raw = reqRow?.SupplierRequestJSON;

    try {
      if (raw && typeof raw === 'string') reqPayload = { ...reqRow, ...JSON.parse(raw) };
      else if (raw && typeof raw === 'object') reqPayload = { ...reqRow, ...raw };
    } catch {
      // keep reqRow only
      reqPayload = { ...reqRow };
    }

    // 2) Normalize SupplierID (blank => null)
    const supplierId =
      reqPayload?.SupplierID && reqPayload.SupplierID.toString().trim() !== ''
        ? Number(reqPayload.SupplierID)
        : null;

    // 3) Map fields into supplier-like model
    const model: SupplierFromRequestModel = {
      SupplierRequestID: reqRow?.SupplierRequestID,
      SupplierID: supplierId,
      responder: reqPayload?.responder ?? reqRow?.responder ?? '',
    };

    this.supplierFieldMap.forEach(m => {
      const val = reqPayload?.[m.req];
      if (val !== undefined && val !== null && val !== '') {
        (model as any)[m.db] = val;
      }
    });

    // 4) Ensure name is present
    model.SupplierName = (model.SupplierName ?? reqPayload?.CompanyName ?? '').toString();

    return model;
  }

  async SupplierRequestSelected(reqRow: any) {
    this.selectedView = { value: 4, label: 'Supplier Requests' };
    this.RequestEditModel = this.buildSupplierModelFromRequest(reqRow);
    // Pull the full request payload so we can access OrganicCertification
    let reqPayload: any = reqRow;
    try {
      const raw = reqRow?.SupplierRequestJSON;
      if (raw && typeof raw === 'string') reqPayload = { ...reqRow, ...JSON.parse(raw) };
      else if (raw && typeof raw === 'object') reqPayload = { ...reqRow, ...raw };
    } catch { }

    // ✅ Files from request
    this.RequestFiles = this.parseRequestFiles(reqPayload?.OrganicCertification);

    // ✅ destination folder preview
    const id = this.RequestEditModel?.SupplierID;
    this.RequestFilesDestFolder = id
      ? `suppliers/supplier-${id}/`
      : `suppliers/supplier-(new)/`;
    this.RequestMode = this.RequestEditModel?.SupplierID ? 'update' : 'new';

    // bind form
    this.SelectedVender = this.RequestEditModel;

    // NEW: load current supplier for compare
    if (this.RequestMode === 'update' && this.RequestEditModel?.SupplierID) {
      await this.loadCurrentSupplierForCompare(Number(this.RequestEditModel.SupplierID));
    } else {
      this.CurrentSupplierRaw = null;
      this.CurrentSupplierCompare = null;
    }
  }
  private clean(v: any): any {
    if (v === null || v === undefined) return undefined;
    if (typeof v === 'string' && v.trim() === '') return undefined;
    return v;
  }

  private buildMergeSupplierPayload(m: SupplierFromRequestModel): any {
    const payload: any = {};

    // SupplierID logic
    payload.SupplierID = m.SupplierID ? Number(m.SupplierID) : null;

    // Basic info
    payload.SupplierName = this.clean(m.SupplierName);
    payload.SupplierContactCountry = this.clean(m.SupplierContactCountry);
    payload.SupplierFDA = this.clean(m.SupplierFDA);
    payload.SupplierFLOID = this.clean(m.SupplierFLOID);
    payload.SupplierFTUSAID = this.clean(m.SupplierFTUSAID);
    payload.SupplierContactSkypeHandle = this.clean(m.SupplierContactSkypeHandle);

    // Trader contact (compose SupplierContact)
    const traderFull = [m.TraderContactFirstName, m.TraderContactLastName].filter(Boolean).join(' ').trim();
    payload.SupplierContact = this.clean(traderFull);
    payload.SupplierEmail = this.clean(m.SupplierEmail);
    payload.SupplierTel = this.clean(m.SupplierTel);
    payload.SupplierStreet = this.clean(m.SupplierStreet);
    payload.SupplierCity = this.clean(m.SupplierCity);
    payload.SupplierState = this.clean(m.SupplierState);
    payload.SupplierZip = this.clean(m.SupplierZip);

    // App/Rej emails
    payload.AppRejEmailNo1 = this.clean(m.AppRejEmailNo1);
    payload.AppRejEmailNo2 = this.clean(m.AppRejEmailNo2);
    payload.AppRejEmailNo3 = this.clean(m.AppRejEmailNo3);

    // Trader secondary emails
    payload.TraderSecondaryEmail1 = this.clean(m.TraderSecondaryEmail1);
    payload.TraderSecondaryEmail2 = this.clean(m.TraderSecondaryEmail2);
    payload.TraderSecondaryEmail3 = this.clean(m.TraderSecondaryEmail3);

    // Traffic (compose TrafficContact)
    const trafficFull = [m.TrafficContactFirstName, m.TrafficContactLastName].filter(Boolean).join(' ').trim();
    payload.TrafficContact = this.clean(trafficFull);
    payload.SupplierTrafficEmail = this.clean(m.SupplierTrafficEmail);
    payload.TrafficNo = this.clean(m.TrafficNo);

    payload.TrafficSecondaryEmail1 = this.clean(m.TrafficSecondaryEmail1);
    payload.TrafficSecondaryEmail2 = this.clean(m.TrafficSecondaryEmail2);
    payload.TrafficSecondaryEmail3 = this.clean(m.TrafficSecondaryEmail3);

    // Price Fix
    payload.PriceFixFirstName = this.clean(m.PriceFixFirstName);
    payload.PriceFixLastName = this.clean(m.PriceFixLastName);
    payload.PriceFixEmail = this.clean(m.PriceFixEmail);
    payload.PriceFixPhone = this.clean(m.PriceFixPhone);

    payload.PriceFixSecondaryEmail1 = this.clean(m.PriceFixSecondaryEmail1);
    payload.PriceFixSecondaryEmail2 = this.clean(m.PriceFixSecondaryEmail2);
    payload.PriceFixSecondaryEmail3 = this.clean(m.PriceFixSecondaryEmail3);

    // Remove undefined keys so API payload is clean
    Object.keys(payload).forEach(k => payload[k] === undefined && delete payload[k]);

    return payload;
  }

  previewMergePayload() {
    if (!this.RequestEditModel) return;
    const payload = this.buildMergeSupplierPayload(this.RequestEditModel);
    this.RequestMergePreviewJson = JSON.stringify(payload, null, 2);
  }

  async runMergeSupplierFromRequest() {
    if (!this.RequestEditModel) return;

    try {
      const payload = this.buildMergeSupplierPayload(this.RequestEditModel);

      await lastValueFrom(
        this.web.getWebCall('venders', '/merge_supplier', {
          body: { supplierJson: JSON.stringify(payload), SupplierRequestID: this.SelectedVender.SupplierRequestID }
        })
      );

      const name = payload.SupplierName ?? '(unknown)';
      this.message.success(`${payload.SupplierID ? 'Updated' : 'Created'} Supplier ${name}`);

      // Refresh lists and keep user in view 4
      await this.ngOnInit();
      this.selectedView = { value: 4, label: 'Supplier Requests' };
    } catch (err) {
      console.error(err);
    }
  }
  private normalizeEmpty(v: any): string {
    if (v === null || v === undefined) return '';
    const s = String(v).trim();
    return s;
  }

  displayVal(v: any): string {
    const s = this.normalizeEmpty(v);
    return s === '' ? '—' : s;
  }

  isChanged(oldVal: any, newVal: any): boolean {
    return this.normalizeEmpty(oldVal) !== this.normalizeEmpty(newVal);
  }

  private splitName(full: any): { first: string; last: string } {
    const parts = this.normalizeEmpty(full).split(/\s+/).filter(Boolean);
    return {
      first: parts[0] ?? '',
      last: parts.length > 1 ? parts.slice(1).join(' ') : ''
    };
  }

  private mapCurrentSupplierToCompareModel(cur: any): SupplierFromRequestModel {
    const trader = this.splitName(cur?.SupplierContact);
    const traffic = this.splitName(cur?.TrafficContact);

    return {
      SupplierID: cur?.SupplierID ?? null,
      SupplierName: cur?.SupplierName ?? '',

      SupplierContactCountry: cur?.SupplierContactCountry ?? '',
      SupplierFDA: cur?.SupplierFDA ?? '',
      SupplierFLOID: cur?.SupplierFLOID ?? '',
      SupplierFTUSAID: cur?.SupplierFTUSAID ?? '',
      SupplierContactSkypeHandle: cur?.SupplierContactSkypeHandle ?? '',

      TraderContactFirstName: trader.first,
      TraderContactLastName: trader.last,
      SupplierEmail: cur?.SupplierEmail ?? '',
      SupplierTel: cur?.SupplierTel ?? '',
      SupplierStreet: cur?.SupplierStreet ?? '',
      SupplierCity: cur?.SupplierCity ?? '',
      SupplierState: cur?.SupplierState ?? '',
      SupplierZip: cur?.SupplierZip ?? '',

      AppRejEmailNo1: cur?.AppRejEmailNo1 ?? '',
      AppRejEmailNo2: cur?.AppRejEmailNo2 ?? '',
      AppRejEmailNo3: cur?.AppRejEmailNo3 ?? '',

      TraderSecondaryEmail1: cur?.TraderSecondaryEmail1 ?? '',
      TraderSecondaryEmail2: cur?.TraderSecondaryEmail2 ?? '',
      TraderSecondaryEmail3: cur?.TraderSecondaryEmail3 ?? '',

      TrafficContactFirstName: traffic.first,
      TrafficContactLastName: traffic.last,
      SupplierTrafficEmail: cur?.SupplierTrafficEmail ?? '',
      TrafficNo: cur?.TrafficNo ?? '',

      TrafficSecondaryEmail1: cur?.TrafficSecondaryEmail1 ?? '',
      TrafficSecondaryEmail2: cur?.TrafficSecondaryEmail2 ?? '',
      TrafficSecondaryEmail3: cur?.TrafficSecondaryEmail3 ?? '',

      PriceFixFirstName: cur?.PriceFixFirstName ?? '',
      PriceFixLastName: cur?.PriceFixLastName ?? '',
      PriceFixEmail: cur?.PriceFixEmail ?? '',
      PriceFixPhone: cur?.PriceFixPhone ?? '',

      PriceFixSecondaryEmail1: cur?.PriceFixSecondaryEmail1 ?? '',
      PriceFixSecondaryEmail2: cur?.PriceFixSecondaryEmail2 ?? '',
      PriceFixSecondaryEmail3: cur?.PriceFixSecondaryEmail3 ?? '',
    };
  }

  private async loadCurrentSupplierForCompare(supplierId: number): Promise<void> {
    this.CurrentSupplierRaw = null;
    this.CurrentSupplierCompare = null;

    try {
      const pull = await lastValueFrom(
        this.web.getWebCall('venders', 'supplier', {
          params: [{ value: supplierId, name: 'SupplierID' }]
        })
      );

      const cur = Array.isArray(pull) ? pull[0] : null;
      this.CurrentSupplierRaw = cur;
      this.CurrentSupplierCompare = cur ? this.mapCurrentSupplierToCompareModel(cur) : null;
    } catch (e) {
      console.error('Could not load current supplier for compare', e);
    }
  }
  async generateSupplierPdf(): Promise<{ fileName: string; base64: string }> {
    const replacements = this.buildSupplierPdfReplacements(this.SelectedVender);
    return await lastValueFrom(
      this.web.getWebCall('pdf', 'generate', {
        body: {
          templatePath: 'templates/pdf-templates/supplier-info.template.html',
          replacements,
          fileName: `Supplier_${this.SelectedVender.SupplierName}.pdf`
        }
      })
    );
  }
  private buildSupplierPdfReplacements(v: any): Record<string, string> {
    return {
      '@@DearName@@': v.SupplierName ?? '',
      '@@SupplierContactCountry@@': v.SupplierContactCountry ?? '',
      '@@SupplierFDA@@': v.SupplierFDA ?? '',
      '@@SupplierFLOID@@': v.SupplierFLOID ?? '',
      '@@SupplierFTUSAID@@': v.SupplierFTUSAID ?? '',

      '@@TraderContactName@@': v.SupplierContact ?? '',
      '@@SupplierEmail@@': v.SupplierEmail ?? '',
      '@@SupplierTel@@': v.SupplierTel ?? '',
      '@@SupplierStreet@@': v.SupplierStreet ?? '',
      '@@SupplierCity@@': v.SupplierCity ?? '',
      '@@SupplierState@@': v.SupplierState ?? '',
      '@@SupplierZip@@': v.SupplierZip ?? '',

      '@@TrafficContactName@@': v.TrafficContact ?? '',
      '@@SupplierTrafficEmail@@': v.SupplierTrafficEmail ?? '',
      '@@TrafficNo@@': v.TrafficNo ?? '',

      '@@PriceFixContactName@@': `${v.PriceFixFirstName ?? ''} ${v.PriceFixLastName ?? ''}`.trim(),
      '@@PriceFixEmail@@': v.PriceFixEmail ?? '',
      '@@PriceFixPhone@@': v.PriceFixPhone ?? '',

      '@@GeneratedDate@@': new Date().toLocaleDateString()
    };
  }
  async UploadDocument(uploadData: any) {
    const files: File[] = uploadData.files;
    const path: string = uploadData.path;

    for (const file of files) {

      // 2) Resolve base filename
      let baseName: string | undefined;
      const {closed$} = this.prompt.open({
          promptText: `Please enter a file name for this document:${file.name}`,
          promptInput: 'text',
          inputLabel: 'File Name',
          inputRequired: true,
          buttons: [
            { label: 'Save', value: true, buttonClass: 'btn-bg-green' }
          ]
      });

      closed$.subscribe(res => {
        if (!res || res.buttonVAlue === false || res.inputValue?.trim()) {
          this.message.error(`No filename entered for ${file.name}. Skipping.`);
          return;
        }
        baseName = res.inputValue.trim();
      })

      const extWithDot = getExtWithDot(file.name); // e.g., ".pdf"
      let finalName = sanitizeFilename(`${baseName}${extWithDot}`);

      // 4) Upload
      const form = new FormData();
      form.append('file', file);
      form.append('fileName', finalName);
      form.append('path', path);

      await lastValueFrom(
        this.web.getWebCall('files', '/upload', { body: form })
      );

      this.message.success(`${finalName} uploaded successfully.`);
    }

    // Refresh once after all uploads finish
    await this.ngOnInit();
    this.fileExplorer?.refresh();
  }
  private parseRequestFiles(v: any): RequestFileItem[] {
    if (!v) return [];
    if (Array.isArray(v)) return v as RequestFileItem[];

    // sometimes stored as stringified JSON
    if (typeof v === 'string') {
      try {
        const parsed = JSON.parse(v);
        return Array.isArray(parsed) ? (parsed as RequestFileItem[]) : [];
      } catch {
        return [];
      }
    }

    return [];
  }

  formatBytes(bytes?: number): string {
    const n = Number(bytes);
    if (!Number.isFinite(n) || n <= 0) return '';
    const units = ['B', 'KB', 'MB', 'GB'];
    let i = 0, v = n;
    while (v >= 1024 && i < units.length - 1) { v /= 1024; i++; }
    return `${v.toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
  }

  async openRequestFile(f: RequestFileItem) {
    const pdfBlob = await lastValueFrom(this.web.getWebCall('files', '/plumsail-pdf', { params: [{ name: 'name', value: 'OrganicCert' }, { name: 'url', value: f.url }], responseType: 'blob' }))

    const objUrl = URL.createObjectURL(pdfBlob);
    this.popup.open({ reportUrl: this.sanitizer.bypassSecurityTrustResourceUrl(objUrl), title: 'Organic Cert' });
  }

}
